import zxcvbn from 'zxcvbn'

export const passwordValidator = zxcvbn
